module.exports = __webpack_public_path__ + "media/images/new_landing/people/peter-varga-14834a5dc766e835a773e21c424c47ce.jpeg";